import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';

import { Columns } from '../user-page-view/user-page-view.component';

@Component({
  selector: 'app-columns-filter-modal',
  templateUrl: './columns-filter-modal.component.html',
  styleUrls: ['./columns-filter-modal.component.scss']
})
export class ColumnsFilterModalComponent implements OnInit {
  public columnTitles: any[] = [
    { key: 'username', title: 'Username' },
    { key: 'pattern', title: 'Pattern' },
    { key: 'licence', title: 'Licence' },
    { key: 'usage', title: 'Usage' },
    { key: 'activations', title: 'Activations' },
    { key: 'fullname', title: 'Name' },
    { key: 'labels', title: 'Labels' },
    { key: 'mail', title: 'Mail' },
    { key: 'roles', title: 'Roles' },
    { key: 'registered', title: 'Registered' },
    { key: 'created', title: 'Created' },
    { key: 'expiry', title: 'Expires' }
  ];

  @Input() public columns: Columns;
  @Output() public onSubmit = new EventEmitter<Columns>();

  constructor(public modal: NgbActiveModal) {}

  public ngOnInit(): void {
    if (environment.developer) {
      this.columnTitles.unshift({ key: 'uuid', title: 'UUID' });
    }
  }

  public apply(key: string, value: boolean) {
    this.columns[key] = value;
  }

  public submit(): void {
    this.onSubmit.emit(this.columns);
    this.modal.close();
  }
}
